/* OneVine: "Find a Mass near you" (Mass page V6). A zip-code field.
   Now: it opens a map of the Catholic churches near that zip code (the block's "Fallback page", {zip} replaced).
   Later, when a Mass-times service allows it (MassTimes.org's data needs their written permission), set the block's
   "Mass times service" to a URL that takes ?lat=..&long=.. and answers like apiv4.updateparishdata.org/Churchs/:
   the page then turns the zip into coordinates (api.zippopotam.us) and lists the nearest churches and their times. */
(function () {
  'use strict';
  function start() {
    var box = document.querySelector('[data-m6-finder]');
    if (!box) return;
    var form = box.querySelector('[data-m6-finder-form]'), input = box.querySelector('[data-m6-zip]');
    var status = box.querySelector('[data-m6-finder-status]'), list = box.querySelector('[data-m6-finder-list]');
    var endpoint = box.dataset.endpoint, fallback = box.dataset.fallback || '';
    function say(text) { status.textContent = text; }
    function open(zip) { var url = fallback.replace('{zip}', encodeURIComponent(zip)); window.open(url, '_blank', 'noopener'); }
    function clean(s) { return String(s == null ? '' : s).trim(); }
    function time(t) { var m = /^(\d\d):(\d\d)/.exec(t || ''); if (!m) return ''; var h = +m[1], ap = h < 12 ? 'am' : 'pm'; h = h % 12 || 12; return h + (m[2] === '00' ? '' : ':' + m[2]) + ' ' + ap; }
    function render(churches, zip) {
      list.innerHTML = '';
      churches.slice(0, 8).forEach(function (c) {
        var li = document.createElement('li'); li.className = 'm6-finder__item';
        var name = document.createElement('p'); name.className = 'm6-finder__name'; name.textContent = clean(c.name);
        var meta = document.createElement('p'); meta.className = 'm6-finder__meta';
        meta.textContent = [clean(c.church_address_street_address), clean(c.church_address_city_name)].filter(Boolean).join(', ') + (c.distance ? ' · ' + (+c.distance).toFixed(1) + ' mi' : '');
        var sunday = (c.church_worship_times || []).filter(function (w) { return /weekend/i.test(w.service_typename || ''); })
          .map(function (w) { return clean(w.day_of_week).slice(0, 3) + ' ' + time(w.time_start); });
        li.appendChild(name); li.appendChild(meta);
        if (sunday.length) { var t = document.createElement('p'); t.className = 'm6-finder__times'; t.textContent = sunday.join(' · '); li.appendChild(t); }
        if (c.url) {
          var links = document.createElement('p'); links.className = 'm6-finder__links';
          var a = document.createElement('a'); a.href = /^https?:/.test(c.url) ? c.url : 'http://' + c.url; a.target = '_blank'; a.rel = 'noopener'; a.textContent = 'Parish website';
          links.appendChild(a); li.appendChild(links);
        }
        list.appendChild(li);
      });
      say(churches.length ? '' : 'No churches found near ' + zip + '.');
    }
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var zip = (input.value || '').replace(/\D/g, '').slice(0, 5);
      if (zip.length !== 5) { say('Please type a 5-digit zip code.'); input.focus(); return; }
      if (!endpoint) { say(''); open(zip); return; }
      say('Looking near ' + zip + '…');
      fetch('https://api.zippopotam.us/us/' + zip).then(function (r) { if (!r.ok) throw new Error('zip'); return r.json(); }).then(function (z) {
        var place = z.places && z.places[0];
        if (!place) throw new Error('zip');
        var sep = endpoint.indexOf('?') < 0 ? '?' : '&';
        return fetch(endpoint + sep + 'lat=' + encodeURIComponent(place.latitude) + '&long=' + encodeURIComponent(place.longitude) + '&pg=1').then(function (r) { if (!r.ok) throw new Error('times'); return r.json(); });
      }).then(function (churches) { render(churches || [], zip); }, function () { say('That did not work. Opening a map instead.'); open(zip); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
